module.exports = __webpack_public_path__ + "assets/TikTok.svg";


//////////////////
// WEBPACK FOOTER
// ./images/icons/TikTok.svg
// module id = 765
// module chunks = 0